import { BaseModelService } from './BaseService'
import { Teacher, TeacherRoleType } from 'kuaidong-model'

export class TeacherService extends BaseModelService<Teacher> {
  get name() {
    return this.model.teacher_name
  }

  get callName() {
    return TeacherService.buildName(this.model.teacher_name)
  }

  public static role(teacherRole: TeacherRoleType = 'others') {
    return this.roleValueToName(teacherRole)
  }

  public static roleValueMap = {
    pe_teacher: '体育老师',
    head_teacher: '班主任',
    others: '其他老师',
    school_manager: '学校管理者',
    pe_manager: '体育组长',
    grade_manager: '年级组长',
    gov: '教育行政部门',
  }

  public static authValueMap = {
    normal: '普通',
    admin: '管理员',
  }

  public static roleValueToName(value: TeacherRoleType = 'others', isUniversity = false) {
    return isUniversity && value === 'head_teacher' ? '辅导员' : this.roleValueMap[value]
  }

  public static roleNameToValue(name: string): TeacherRoleType {
    return this.buildRoleOptions().find((o) => o.label === name)?.value || 'others'
  }

  public static authValueToName(value: 'normal' | 'admin' = 'normal') {
    return this.authValueMap[value]
  }

  public static buildName(name?: string | null) {
    if (name) {
      return name.includes('老师') ? name : `${name}老师`
    }

    return '老师'
  }

  public static buildRoleOptions(isUniversity = false) {
    return Object.keys(this.roleValueMap).map((k: any) => {
      return {
        value: k,
        label: this.roleValueToName(k, isUniversity),
      }
    })
  }

  public static buildSystemRoleOptions() {
    return [
      {
        value: false,
        label: '普通',
      },
      {
        value: true,
        label: '管理员',
      },
    ]
  }

  public static showSystemRole(teacherRole: { admin?: string }) {
    if (teacherRole.admin === 'super_admin') {
      return '超级管理员'
    } else if (teacherRole.admin === 'admin') {
      return '管理员'
    } else {
      return '普通'
    }
  }

  public static buildRoleStr(options: { isSuperAdmin?: boolean; isAdmin?: boolean }) {
    if (options.isSuperAdmin) {
      return 'super_admin'
    } else if (options.isAdmin) {
      return 'admin'
    } else {
      return ''
    }
  }
}
